import {
  GET_ACCOUNT_NAME,
  GET_ACCOUNT_NAME_SUCCESS,
  GET_ACCOUNT_NAME_FAILURE,
} from '../actions/accountName';

const INITIAL_STATE = { loading: false, cached: false };

export default function accountNameReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_ACCOUNT_NAME:
      return {
        ...state,
        cached: true,
        loading: true,
      };
    case GET_ACCOUNT_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        accountName: action.payload.accountName,
      };
    case GET_ACCOUNT_NAME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
